import { graphql } from "@/gql/__generated__";

export const notificationQuery = graphql(`
  query NotificationQuery {
    viewer {
      id
      status
      isSuspended
      isIdentification
      fiveMinWorkReminderDisplayedId
      addHomeScreenDisplayed
      hasProfile
      hasAddress
      hasLineAccount
      hasDeviceToken
    }
    address {
      prefecture
    }
    usageStatus {
      workedCount
    }
  }
`);

export const displayFiveMinWorkReminderMutation = graphql(`
  mutation DisplayedFiveMinWorkReminderInput(
    $input: DisplayedFiveMinWorkReminderInput!
  ) {
    displayedFiveMinWorkReminder(input: $input) {
      viewer {
        id
      }
      temporaryJobOffer {
        id
      }
    }
  }
`);

export const displayedAddHomeScreenMutation = graphql(`
  mutation DisplayedAddHomeScreenInput($input: DisplayedAddHomeScreenInput!) {
    displayedAddHomeScreen(input: $input) {
      viewer {
        id
      }
    }
  }
`);

export const registerAddressMutation = graphql(`
  mutation RegisterAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      temporaryJobWorker {
        id
        addressExists
      }
    }
  }
`);
